import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../../app/store";
import { CredentialsChat } from "../../model/credentials-chat";
export interface CredentialsState {
  value: CredentialsChat;
  loading: boolean;
  alreadyLoggedByParam: boolean;
}

const initialState: CredentialsState = {
  value: null,
  loading: true,
  alreadyLoggedByParam: false,
};

export const credentialsSlice = createSlice({
  name: "credentials",
  initialState: initialState,
  reducers: {
    setCredentials: (
      state: CredentialsState,
      action: PayloadAction<CredentialsChat>
    ) => {
      state.value = action.payload;
    },
    setCredentialsLoading: (
      state: CredentialsState,
      action: PayloadAction<boolean>
    ) => {
      state.loading = action.payload;
    },
    setAlreadyLoggedByParam: (
      state: CredentialsState,
      action: PayloadAction<boolean>
    ) => {
      state.alreadyLoggedByParam = action.payload;
    },
  },
});

export const {
  setCredentials,
  setCredentialsLoading,
  setAlreadyLoggedByParam,
} = credentialsSlice.actions;

export const selectCredentials = (state: RootState) => state.credentials.value;
export const selectCredentialsLoading = (state: RootState) =>
  state.credentials.loading;
export const selectAlreadyLoggedByParam = (state: RootState) =>
  state.credentials.alreadyLoggedByParam;

export default credentialsSlice.reducer;
